<script lang="ts">
	import { page } from '$app/stores';
	import { hideMenu } from '../mypage/store';
	import type { LayoutData } from './$types';

	type Menu = {
		icon: string;
		selectedIcon: string;
		title: string;
		url: string;
	};

	const getCurrentPath = () => {
		const urlPart = $page.url.pathname;

		return urlPart;
	};

	let currentPath = getCurrentPath();

	$: {
		$page.url;
		currentPath = getCurrentPath();
	}

	const menuGroups: Menu[][] = [
		[
			{
				icon: '/sidemenu/user.svg',
				selectedIcon: '/sidemenu/user_select.svg',
				title: '개인정보처리방침',
				url: '/policy/privacy'
			},
			{
				icon: '/sidemenu/order.svg',
				selectedIcon: '/sidemenu/order_select.svg',
				title: '이용약관',
				url: '/policy/terms'
			},
			{
				icon: '/sidemenu/qna.svg',
				selectedIcon: '/sidemenu/qna_select.svg',
				title: '이메일무단수집거부',
				url: '/policy/email-rejection'
			}
		]
	];
</script>

<div class="relative flex items-center w-full root">
	<div class="flex w-full h-full mobile:w-min-mobile desktop:w-min-desktop">
		<div
			class="mobile:w-min-mobile w-full desktop:w-[174px] shrink-0 px-4 desktop:px-0 h-full flex-col sticky top-0 bg-white {$hideMenu
				? 'hidden desktop:flex'
				: 'flex'}"
		>
			<div
				class="h-[60px] desktop:h-[79px] text-basic-black flex justify-start items-center text-h5 desktop:px-4 desktop:text-h4 shrink-0"
			>
				이용안내
			</div>
			{#key currentPath}
				<div class="menu-scroll">
					{#each menuGroups as menuGroup}
						<div class="menu-group">
							{#each menuGroup as menu}
								<div
									class="rounded-xl hover:bg-etc-200"
									class:selected-menu={currentPath == menu.url}
								>
									<a
										class="flex items-center justify-start h-12 px-2 space-x-1.5 rounded-[12px]"
										on:click={() => {
											hideMenu.set(true);
										}}
										href={menu.url}
									>
										<img
											class="w-6 h-6"
											src={currentPath == menu.url ? menu.selectedIcon : menu.icon}
											alt=""
										/>
										<span class=" text-basic-black-100 text-body-large whitespace-nowrap"
											>{menu.title}</span
										>
									</a>
								</div>
							{/each}
						</div>
					{/each}
				</div>
			{/key}
		</div>
		<div class="w-full desktop:ml-[30px] {!$hideMenu ? 'hidden desktop:flex' : 'flex'}">
			<slot />
		</div>
	</div>
</div>

<style lang="postcss">
	.menu-group {
		@apply flex flex-col pb-4 space-y-2 border-b-[1px] border-gray-100 mb-4;
	}

	.menu-group:last-child {
		@apply border-none;
	}

	.selected-menu {
		@apply bg-primary-50;
	}

	.selected-menu > a > span {
		@apply text-primary-100;
	}
</style>
